var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentPage"},[_c('NavBar',{attrs:{"titleTranslationPath":"profileOverview.title","location":"","commune":""}}),_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('TabBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }